export const ActionType = {
  Corrective: 'Corrective',
  Preventive: 'Preventive',
};
